"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICON_SETS = void 0;
exports.ICON_SETS = [
    { value: 'simple-line-icons', label: 'Simple Line Icons' },
    { value: 'iconsminds', label: 'IconsMinds' }
];
